var options = {
    types: ['geocode'],
    componentRestrictions: {country: 'fr'}
};
var autocompletes = [];
var actuel_id;
var addr_cp, addr_ville, addr_numdep, addr_nomdep;

var setAdresse = window.setAdresse = function(input){
    var theId = $(input).attr('id');
    if (!theId) {
        console.error('Input does not have an id attribute');
        return;
    }

    if (theId.startsWith('datas.')) {
        var stepNum = theId.split('datas.')[1];
    
        if(stepNum != ''){
            step = stepNum.split('.')[0];
            idAdresseAuto = stepNum.split('.')[1];
    
            addr_cp = 'datas.'+step+'.'+$('input[data-adress="'+idAdresseAuto+'.cp"]').attr('name');
            addr_ville = 'datas.'+step+'.'+$('input[data-adress="'+idAdresseAuto+'.ville"]').attr('name');
            addr_numdep = 'datas.'+step+'.'+$('input[data-adress="'+idAdresseAuto+'.numdep"]').attr('name');
            addr_nomdep = 'datas.'+step+'.'+$('input[data-adress="'+idAdresseAuto+'.nomdep"]').attr('name');
            addr_pays = 'datas.'+step+'.'+$('input[data-adress="'+idAdresseAuto+'.pays"]').attr('name');
        }
    } else {
        idAdresseAuto = theId;
        addr_cp = $('input[data-adress="'+idAdresseAuto+'.cp"]').attr('name');
        addr_ville = $('input[data-adress="'+idAdresseAuto+'.ville"]').attr('name');
        addr_numdep = $('input[data-adress="'+idAdresseAuto+'.numdep"]').attr('name');
        addr_nomdep = $('input[data-adress="'+idAdresseAuto+'.nomdep"]').attr('name');
        addr_pays = $('input[data-adress="'+idAdresseAuto+'.pays"]').attr('name');
    }
};

var searchAdresses = window.searchAdresses = function(inputs){
    for (var i = 0; i < inputs.length; i++) {
        var autocomplete = new google.maps.places.Autocomplete(inputs[i], options);
        autocomplete.inputId = inputs[i].id;
        autocomplete.addListener('place_changed', function() {
            actuel_id = this.inputId;
            var place = this.getPlace();

            //Adresse
            document.getElementById(this.inputId).value = place.address_components[0].long_name+' '+place.address_components[1].long_name;
            setDataLive(actuel_id,place.address_components[0].long_name+' '+place.address_components[1].long_name);
            if (place.address_components[6] != undefined){
                //Code postal
                $('input[data-adress="'+idAdresseAuto+'.cp"]').value = place.address_components[6].long_name;
                setDataLive(addr_cp,place.address_components[6].long_name);
                //Arrondissement + Ville
                var code_postal = place.address_components[6].long_name;
                var arrondissement = '"' + code_postal + '"';

                if ( place.address_components[2].long_name == 'Paris' ) {
                    //var nomVille = arrondissement.substring(4, 6)+'e Arrondissement de Paris';
                    var nomVille = place.address_components[2].long_name;
                } else if ( place.address_components[2].long_name == 'Marseille' ) {
                    //var nomVille = arrondissement.substring(4, 6)+'e Arrondissement de Marseille';
                    var nomVille = place.address_components[2].long_name;
                } else if ( place.address_components[2].long_name == 'Lyon' ) {
                    //var nomVille = arrondissement.substring(4, 6)+'e Arrondissement de Lyon';
                    var nomVille = place.address_components[2].long_name;
                } else {
                    var nomVille = place.address_components[2].long_name;
                }
                $('input[data-adress="'+idAdresseAuto+'.ville"]').value = nomVille.toUpperCase();
                setDataLive(addr_ville,nomVille.toUpperCase());

                //Département + Son numéro
                if (place.address_components[3] != undefined) {
                    //Numéro
                    if (document.getElementById(addr_numdep) !== null && place.address_components[6] != undefined) {
                        document.getElementById(addr_numdep).value = place.address_components[6].long_name.substr(0, 2);
                        setDataLive(addr_numdep,place.address_components[6].long_name.substr(0, 2));
                    }
                    //Nom
                    if (document.getElementById(addr_nomdep) !== null) {
                        if ( place.address_components[2].long_name == 'Paris' ) {
                            document.getElementById(addr_nomdep).value = place.address_components[2].long_name;
                             setDataLive(addr_nomdep,place.address_components[2].long_name);
                        } else {
                            document.getElementById(addr_nomdep).value = place.address_components[3].long_name;
                             setDataLive(addr_nomdep,place.address_components[3].long_name);
                        }
                    }
                }

                //Pays
                if (document.getElementById(addr_pays) !== null) {
                    if (place.address_components[5] != undefined) {
                        document.getElementById(addr_pays).value = place.address_components[5].long_name;
                        setDataLive(addr_pays,place.address_components[5].long_name);
                    }
                }

            } else {
                document.getElementById(this.inputId).value = place.address_components[0].long_name;
                $('input[data-adress="'+idAdresseAuto+'.ville"]').value = place.address_components[1].long_name.toUpperCase();
                setDataLive(actuel_id,place.address_components[0].long_name);
                // On ne met pas le département dans le champ ville
                if (addr_ville != undefined && document.getElementById(addr_ville) != null){
                    // On vérifie que l'adresse n'est pas une ville
                    if(place.address_components[1]['types'] != undefined && $.inArray("locality",place.address_components[1]['types']) !== -1){
                        document.getElementById(addr_ville).value = place.address_components[1].long_name;
                        setDataLive(addr_ville,place.address_components[1].long_name.toUpperCase());
                    }
                }
                if (addr_nomdep != undefined && document.getElementById(addr_nomdep) != null){
                    document.getElementById(addr_nomdep).value = place.address_components[3].long_name;
                    setDataLive(addr_nomdep,place.address_components[3].long_name);
                }
                if(place.address_components[5] != undefined){
                    if($('input[data-adress="'+idAdresseAuto+'.cp"]') != null){
                        $('input[data-adress="'+idAdresseAuto+'.cp"]').value = place.address_components[5].long_name;
                        setDataLive(addr_cp,place.address_components[5].long_name);
                    }
                    if(document.getElementById(addr_numdep) != null){
                        document.getElementById(addr_numdep).value = place.address_components[5].long_name.substr(0, 2);
                        setDataLive(addr_numdep,place.address_components[5].long_name.substr(0, 2));
                    }
                }
            }
        });
        autocompletes.push(autocomplete);
    }
};

// Autocomplete adress
var inputs = $('.address_auto');

$('input.address_auto').focus(function() {
    setAdresse(this);
});

searchAdresses(inputs);
